import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { SparklesIcon, WrenchScrewdriverIcon, ServerIcon, CpuChipIcon } from '@heroicons/react/24/outline'

const stats = [
  { id: 1, name: 'Tasa de Mejora con IA', value: '90%', icon: SparklesIcon },
  { id: 2, name: 'Respuesta de Soporte', value: '<1h', icon: WrenchScrewdriverIcon },
  { id: 3, name: 'Equipos Instalados', value: '500+', icon: CpuChipIcon },
  { id: 4, name: 'Uptime de Servidores', value: '99.9%', icon: ServerIcon },
]

export default function InfoStat() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, easing: 'ease-out-cubic' })
  }, [])

  return (
    <div className="bg-[#f6f6f6] py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-14" data-aos="fade-up">
          <p className="text-xs font-semibold text-[#366D73] tracking-[0.2em] uppercase mb-4">Por qué elegirnos</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#353E40]">
            Software, Hardware y <span className="text-[#366D73]">Soporte Técnico</span>
          </h2>
          <p className="mt-4 text-gray-500 max-w-xl mx-auto">
            Soluciones completas con instalación, mantenimiento y soporte especializado.
          </p>
        </div>

        <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat, index) => (
            <div
              key={stat.id}
              className="group bg-white rounded-2xl p-6 sm:p-8 border border-gray-200/60 hover:border-[#366D73]/30 hover:shadow-[0_4px_20px_-8px_rgba(54,109,115,0.15)] transition-all duration-300"
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className="w-12 h-12 rounded-full bg-[#366D73]/10 flex items-center justify-center mb-5 group-hover:bg-[#366D73]/20 transition-colors">
                <stat.icon className="h-6 w-6 text-[#366D73]" />
              </div>
              <dd className="text-3xl sm:text-4xl font-bold tracking-tight text-[#353E40] mb-1">{stat.value}</dd>
              <dt className="text-sm text-gray-500">{stat.name}</dt>
            </div>
          ))}
        </dl>
      </div>
    </div>
  )
}